import React, { useState } from 'react';
import { Modal, Button, Tabs, Tab } from 'react-bootstrap';
import CongBoTrenWebForm from './CongBoTrenWebForm';
import CongBoThongTinForm from './CongBoThongTinForm';
import NhanXetHoiDongForm from './NhanXetHoiDongForm';
import DieuKienToChucForm from './DieuKienToChucForm';

const CongBoTrenWebModal = ({ dataEdit, setViewMode, isView = false, isUserView = false }) => {
    const [activeTab, setActiveTab] = useState('congBoTrenWeb');
    const [editModes, setEditModes] = useState({
        congBoTrenWeb: false,
        congBoThongTin: false,
        nhanXetHoiDong: false,
        dieuKienToChuc: false
    });

    if (!dataEdit) return null;

    const handleDataLoaded = (tabKey, hasData) => {
        if (!isView && !isUserView) {
            setEditModes(prev => ({ ...prev, [tabKey]: !hasData }));
        }
    };

    const handleSetEditMode = (tabKey, isEdit) => {
        setEditModes(prev => ({ ...prev, [tabKey]: isEdit }));
    };

    return (
        <Modal show={true} onHide={() => setViewMode('list')} size="xl" backdrop="static">
            <Modal.Header closeButton className="bg-info text-white">
                <Modal.Title>{isView || isUserView || !editModes[activeTab] ? 'Điều kiện tổ chức đánh giá luận án cấp viện' : 'Cập nhật Điều kiện tổ chức đánh giá luận án cấp viện'}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0 custom-modal-body" style={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto', overflowX: 'hidden' }}>
                <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} id="cong-bo-tren-web-tabs" className="custom-tabs px-3 pt-3 border-bottom-0">
                    <Tab eventKey="congBoTrenWeb" title={<span className="font-weight-bold">Công bố trên Web</span>}>
                        <div className="bg-light p-3 rounded border mt-3 mb-3 mx-3">
                            <CongBoTrenWebForm 
                                baoVeCapVienId={dataEdit.id} 
                                readOnly={!editModes.congBoTrenWeb || isView || isUserView} 
                                isUserView={isUserView} 
                                onDataLoaded={(hasData) => handleDataLoaded('congBoTrenWeb', hasData)}
                                onSaveSuccess={() => handleSetEditMode('congBoTrenWeb', false)}
                            />
                        </div>
                    </Tab>
                    <Tab eventKey="congBoThongTin" title={<span className="font-weight-bold">Thời gian, địa điểm, tên luận án</span>}>
                        <div className="bg-light p-3 rounded border mt-3 mb-3 mx-3">
                            <CongBoThongTinForm 
                                baoVeCapVienId={dataEdit.id} 
                                readOnly={!editModes.congBoThongTin || isView || isUserView} 
                                isUserView={isUserView} 
                                onDataLoaded={(hasData) => handleDataLoaded('congBoThongTin', hasData)}
                                onSaveSuccess={() => handleSetEditMode('congBoThongTin', false)}
                            />
                        </div>
                    </Tab>
                    <Tab eventKey="nhanXetHoiDong" title={<span className="font-weight-bold">Nhận xét của Hội đồng</span>}>
                        <div className="bg-light p-3 rounded border mt-3 mb-3 mx-3">
                            <NhanXetHoiDongForm 
                                baoVeCapVienId={dataEdit.id} 
                                readOnly={!editModes.nhanXetHoiDong || isView || isUserView} 
                                isUserView={isUserView} 
                                onDataLoaded={(hasData) => handleDataLoaded('nhanXetHoiDong', hasData)}
                                onSaveSuccess={() => handleSetEditMode('nhanXetHoiDong', false)}
                            />
                        </div>
                    </Tab>
                    <Tab eventKey="dieuKienToChuc" title={<span className="font-weight-bold">Điều kiện tổ chức</span>}>
                        <div className="bg-light p-3 rounded border mt-3 mb-3 mx-3">
                            <DieuKienToChucForm 
                                baoVeCapVienId={dataEdit.id} 
                                readOnly={!editModes.dieuKienToChuc || isView || isUserView} 
                                isUserView={isUserView} 
                                onDataLoaded={(hasData) => handleDataLoaded('dieuKienToChuc', hasData)}
                                onSaveSuccess={() => handleSetEditMode('dieuKienToChuc', false)}
                            />
                        </div>
                    </Tab>
                </Tabs>
            </Modal.Body>
            <Modal.Footer>
                {!isView && !isUserView && !editModes[activeTab] && (
                    <Button variant="warning" onClick={() => handleSetEditMode(activeTab, true)}>
                        <i className="fas fa-edit mr-1"></i> Cập nhật
                    </Button>
                )}
                <Button variant="secondary" onClick={() => setViewMode('list')}>
                    Đóng
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CongBoTrenWebModal;
